import { default as React } from 'react';
import { SignupReason } from './SignupCardV2Modified';
import { Column, Row, Text } from '@snowflake/core-ui';
import { useSignupFormData } from './SignupFormDataContext';
import { FormattedMessage } from 'react-intl';
import { CardTemplate } from '../../shared/CardTemplate';
import { FormInputsConfig, SignupFormInputs } from './SignupFormInputs';
import { SignupCardButton } from './SignupCardButton';
import { useEditionAndCloudInputConfigs, useStudentInputConfigs } from './inputConfigs';

interface Props {
  goBack: () => void;
}

export const SignupFormStepTwoModified = (props: Props) => {
  const formData = useSignupFormData();
  const { signupReason } = formData;
  const { goBack } = props;
  const studentInputConfigs = useStudentInputConfigs();
  const editionAndCloudInputConfigs = useEditionAndCloudInputConfigs();

  // For modified flow: only show student-specific field if student, otherwise just edition/cloud
  const inputConfigs: FormInputsConfig = [
    ...(signupReason === SignupReason.Student ? studentInputConfigs : []),
    ...editionAndCloudInputConfigs,
  ];

  return (
    <CardTemplate>
      <Column width="100%" rowGap="24px">
        <Text fontSize="20px" fontWeight="600">
          <FormattedMessage id="Configure your account" />
        </Text>
        <SignupFormInputs configs={inputConfigs} forceRequired={false} />
        <Row>
          <SignupCardButton width="100%" onClick={goBack} buttonType="secondary">
            <FormattedMessage id="Back" />
          </SignupCardButton>
        </Row>
      </Column>
    </CardTemplate>
  );
};
